import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/_components/spinner/spinner.service';
import {Passenger, Ship} from 'src/app/model';
import { ROUTES } from 'src/app/route/routes';
import { CookieStoragerService } from 'src/app/services/cookie-storager.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reservation-another',
  templateUrl: './reservation-another.component.html',
  styleUrls: ['./reservation-another.component.scss'],
  standalone: false
})
export class ReservationAnotherComponent implements OnInit {
  public listPassenger?: Array<Passenger>;
  // spinnerView: boolean = false;
  firstSearch = false;
  availableShips: Array<Ship> = [];
  selectedShip: Ship | null = null;

  constructor(
    private router: Router,
    private reservationService: ReservationService,
    private userService: UserService,
    private cStorager: CookieStoragerService,
    private spinner: SpinnerService
  ) { }

  get passengerSelected(): Passenger | undefined {
    return this.listPassenger?.find((passenger) => passenger.selected);
  }
  get disabledButton(): boolean {
    let passengerSelected = this.passengerSelected;
    return !passengerSelected;
  }

  ngOnInit(): void {
    this.availableShips = this.userService.ships;
    if (this.availableShips.length === 1) {
      this.selectedShip = this.availableShips[0];
    }
  }

  search(numeroCabina: string) {
    if (!numeroCabina) return;
    // this.spinnerView = true;
    this.spinner.show();
    this.firstSearch = true;
    if(this.selectedShip){
      this.reservationService.getPassenger(numeroCabina, this.selectedShip).subscribe({
        next: (res) => {
          this.listPassenger = res;
          // this.spinnerView = false;
          this.spinner.hide();
        },
        error: (err) => {
          console.log(err);
          // this.spinnerView = false;
          this.spinner.hide();
        }
      });
    }
  }

  selectPassenger(passengerSelected: any) {
    this.listPassenger!.forEach((passenger) => {
      passenger.selected = false;
    });
    passengerSelected.selected = true;
  }

  goTo(path: string) {
    switch (path) {
      case 'home':
        this.router.navigate([ROUTES.HOME.path]);
        break;
      case 'landing':
        this.router.navigate([ROUTES.RESERVATION.path]);
        break;
      case 'passenger':
        if (this.passengerSelected) {
          let currentUser = this.userService.getCurrentUser();
          currentUser!.uuidPassenger = this.passengerSelected.uuid_passenger;
          currentUser!.displayNameImp = this.passengerSelected.displayName;
          let expireDate = new Date();
          expireDate.setSeconds(expireDate.getSeconds() + 30);
          this.cStorager.setElement('cu', currentUser, undefined, expireDate, "/", environment.domain);
          window.open(
            environment.portaleFrontendUrl,
            this.passengerSelected.uuid_passenger
          );
          this.router.navigate([ROUTES.HOME.path]);
        }
        break;
    }
  }
}
